module.exports = __webpack_public_path__ + "img/present_white.da0c980d.svg";